<template>
    <div style="height: 100vh;">

      <v-row class="rw">
        <v-col class="skeleton" >
            <Skeleton class='skeleton' height="100vh" width="96vw"></Skeleton>
        </v-col>
      </v-row>

    </div>
  </template>
  <script>
  import Skeleton from "primevue/skeleton";
  export default {
    components: {
      Skeleton,
    },
  };
  </script>
  
  <style>
  .skeleton{
    padding-left:0px !important;
    padding-right:0px !important;
  }
  .rw{
    margin: -16px !important;
  }
  </style>